<template>
  <div>
    <div class="page-title">
      <div class="d-flex items-center">
        <h2 class="text-capitalize">
          {{ farmInfo.name ? farmInfo.name : $t('notSpecified') }}
        </h2>
        <p style="margin: 0 0 0 5px">
          #{{ farmInfo.farmNumber ? farmInfo.farmNumber : $t('notSpecified') }}
        </p>
      </div>
      <v-spacer></v-spacer>
      <v-btn v-if="active" color="primary" dark @click.stop="dialog = true">
        {{$t('farm.registerNewProduct')}}
      </v-btn>
    </div>
    <div class="c-right">
      <v-card flat>
        <v-card-title>
          <v-row class="elevation-0" width="100%">
            <v-col sm="" class="">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle> {{$t('farm.farmType')}} </v-list-item-subtitle>
                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                      {{
                        farmInfo.farmType ? farmInfo.farmType : $t('notSpecified')
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider v-if="!checkBreakPoints" vertical inset></v-divider>
            <v-col sm="" class="">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle> {{$t('farm.farmOwner')}} </v-list-item-subtitle>
                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                      {{
                        farmInfo.owner.name
                          ? farmInfo.owner.name
                          : $t('notSpecified')
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider v-if="!checkBreakPoints" vertical inset></v-divider>
            <v-col sm="" class="">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle> {{$t('farm.farmLocation')}} </v-list-item-subtitle>
                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                      {{
                        farmInfo.city.name
                          ? farmInfo.city.name
                          : $t('notSpecified')
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider v-if="!checkBreakPoints" vertical inset></v-divider>
            <v-col sm="" class="">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{$t('farm.govtRegistry')}} #
                    </v-list-item-subtitle>
                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                      {{
                        farmInfo.govRegistrationNo
                          ? `#${farmInfo.govRegistrationNo}`
                          : $t('notSpecified')
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider v-if="!checkBreakPoints" vertical inset></v-divider>
            <v-col sm="" class="">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle> {{$t('farm.cooperativeID')}} </v-list-item-subtitle>
                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                      {{
                        farmInfo.cooperativeID
                          ? `#${farmInfo.cooperativeID}`
                          : $t('notSpecified')
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider v-if="!checkBreakPoints" vertical inset></v-divider>
            <v-col sm="" class="">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{$t('farm.dateOfRegistration')}}
                    </v-list-item-subtitle>
                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                      {{ date ? date : $t('notSpecified') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </div>
    <register-product
      :newdialog="dialog"
      :unset="unsetDialog"
      :id="$route.params.farmId"
      :getInfo="getStatus"
    ></register-product>
  </div>
</template>
<script>
// import {mapGetters} from "vuex"
import FarmService from "@/_services/farmService";
import loadingMixin from "@/mixins/LoadingMixin";
import RegisterProduct from "./RegisterProduct.vue";
export default {
  name: "FarmInfo",
  components: {
    RegisterProduct,
  },
  // computed: {
  //     ...mapGetters(['active']),
  //   },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  data() {
    return {
      dialog: false,
      date: "",
      farmInfo: {
        owner: {
          name: "abc",
        },
        city: {
          name: "xxx",
        },
      },
    };
  },
  async mounted() {
    await this.getItem();
  },
  methods: {
    getItem() {
      this.startLoading();
      FarmService.getfarm(this.$route.params.farmId)
        .then(async (response) => {
          console.log("res", response);
          this.farmInfo = response;
          this.date = await this.format(response.registeredAt);
          console.log("date", this.date);
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    format(inputDate) {
      var date = new Date(inputDate);
      if (!isNaN(date.getTime())) {
        console.log("mm", date.getMonth());
        // Months use 0 index.
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
      }
    },
    async setDialog() {
      this.dialog = true;
    },
    unsetDialog(data) {
      console.log("hello");
      this.dialog = data;
    },
  },
  props: ["id", "active", "getStatus"],
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
.c-right {
  padding: 0px 0px 50px !important;
}
.border-top {
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: gray;
}
.border-right {
  border-right: 1px solid;
  border-color: gray;
}
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}
.page-title p {
  color: $primary-color;
}

.items-center {
  align-items: center;
}
</style>
